import { render, staticRenderFns } from "./AnalyzeDetails.vue?vue&type=template&id=124b64b1&scoped=true&"
import script from "./AnalyzeDetails.vue?vue&type=script&lang=js&"
export * from "./AnalyzeDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnalyzeDetails.vue?vue&type=style&index=0&id=124b64b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b64b1",
  null
  
)

export default component.exports